import {
  customerDetailApi,
  customerEditApi,
  customerListApi,
  customerRegisterApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { clientActions } from "./actions";

export function* clientSaga() {
  yield takeEveryFsa(clientActions.fetchClients.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      clientActions.fetchClients,
      customerListApi,
    );
  });

  yield takeEveryFsa(
    clientActions.getClientDetails.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        clientActions.getClientDetails,
        customerDetailApi,
      );
    },
  );

  yield takeEveryFsa(
    clientActions.registerNewClient.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        clientActions.registerNewClient,
        customerRegisterApi,
      );
    },
  );

  yield takeEveryFsa(clientActions.updateClient.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      clientActions.updateClient,
      customerEditApi,
    );
  });
}
